const groupOfficerReportTypes = {
	/***************** GET GROUP OFFICER REPORT  START *************** */
	GET_GROUP_OFFICER_REPORT_START: 'get_group_officer_report_start',
	GET_GROUP_OFFICER_REPORT_SUCCESS: 'get_group_officer_report_success',
	GET_GROUP_OFFICER_REPORT_FAILURE: 'get_group_officer_report_failure',
	GET_GROUP_OFFICER_REPORT_RESPONSE_RESET_START: 'get_group_officer_report_reset_start',
	GET_GROUP_OFFICER_REPORT_RESPONSE_RESET_CHANGED: 'get_group_officer_report_response_changed',
	/***************** GET GROUP OFFICER REPORT  END *************** */

	/***************** GET CENTER LIST BASED ON OFFICER START *************** */
	GET_CENTER_LIST_FOR_OFFICER_START: 'get_center_list_for_officer_start',
	GET_CENTER_LIST_FOR_OFFICER_SUCCESS: 'get_center_list_for_officer_success',
	GET_CENTER_LIST_FOR_OFFICER_FAILURE: 'get_center_list_for_officer_failure',
	GET_CENTER_LIST_FOR_OFFICER_RESPONSE_RESET_START: 'get_center_list_for_officer_reset_start',
	GET_CENTER_LIST_FOR_OFFICER_RESPONSE_RESET_CHANGED: 'get_group_officer_report_response_changed',
	/***************** GET CENTER LIST BASED ON OFFICER END *************** */
};
export default groupOfficerReportTypes;
